module.exports = __webpack_public_path__ + "static/media/dog_walk.67619c90.gif";